import {base64DecodeUnicode} from "./utilities/base64";
import {initInputBody} from "./inputfile";
import {initInputMaskDate} from "./inputMaskDate";
import {initPhoneCountryFields} from "./phoneCountryField";
import {focusInputGroups} from "./checkInputGroups";
import {initPasswordFields} from "./password";

const initializedWrappers = new WeakSet();

function setHiddenField(form, name, value) {
    let field = form.querySelector('input[type="hidden"][name="' + name + '"]');
    if (!field) {
        field = document.createElement("input");
        field.type = "hidden";
        field.name = name;
        form.appendChild(field);
    }
    field.value = value;
}

function initFormFields(formWrapper) {
    // Jede Initialisierung einzeln abgesichert: ein Fehler in einem Feldtyp darf die
    // restlichen Felder und vor allem den Submit-Handler nicht mitreissen.
    const steps = [
        () => initInputMaskDate(formWrapper.querySelectorAll('input[type="date"],.js-inputMasketDate')),
        () => initInputBody(formWrapper.querySelectorAll('.fileBody')),
        () => initPhoneCountryFields(formWrapper.querySelectorAll('.js-phoneCountryField')),
        () => focusInputGroups(formWrapper.querySelectorAll('.inputGroup input,.inputGroup select,.inputGroup textarea')),
        () => initPasswordFields(formWrapper)
    ];

    for (const step of steps) {
        try {
            step();
        } catch (err) {
            console.error("[reCAPTCHA] Feld-Initialisierung fehlgeschlagen:", err);
        }
    }

    const contactform = formWrapper.querySelector(".contactform");
    if (contactform) {
        contactform.style.opacity = 1;
    }
}

function loadRecaptchaHtml(formWrapper) {
    const encodedHtml = formWrapper.dataset.html;
    if (!encodedHtml) {
        return;
    }

    // Der Observer feuert fuer jede Attributaenderung am Wrapper und initRecaptchaForms()
    // laedt zusaetzlich direkt. Ohne diesen Guard wuerde bereits eingegebener Text
    // durch ein erneutes innerHTML verworfen.
    if (initializedWrappers.has(formWrapper) && formWrapper.querySelector("form")) {
        return;
    }
    initializedWrappers.add(formWrapper);

    formWrapper.innerHTML = base64DecodeUnicode(encodedHtml);

    const form = formWrapper.querySelector("form");
    if (!form) {
        return;
    }

    // Der Submit-Handler wird vor den Feld-Initialisierungen registriert. Bricht eine
    // Initialisierung ab, wuerde das Formular sonst ohne Token nativ abgeschickt werden
    // und serverseitig in "invalid-input-response" laufen.
    form.addEventListener("submit", function (e) {
        e.preventDefault();

        // form.submit() überträgt den auslösenden Button nicht mit. Formulare, die den
        // Button-Namen serverseitig auswerten (z. B. saveModelFormButton), brauchen ihn als Hidden-Feld.
        if (e.submitter && e.submitter.name) {
            setHiddenField(form, e.submitter.name, e.submitter.value || "");
        }

        if (typeof grecaptcha === "undefined" || !grecaptcha.execute) {
            console.error("[reCAPTCHA] grecaptcha nicht geladen oder execute nicht verfügbar.");
            return;
        }

        grecaptcha.ready(() => {

            const siteKey = form.dataset.sitekey;
            if (!siteKey) {
                console.error("[reCAPTCHA] Site Key nicht gefunden.");
                return;
            }

            grecaptcha.execute(siteKey, {action: 'submit'})
                .then((token) => {
                    // Ohne dieses Feld erreicht der Token die serverseitige Prüfung nicht
                    // und siteverify antwortet mit "invalid-input-response".
                    setHiddenField(form, "g-recaptcha-response", token);

                    const event = new CustomEvent("recaptcha:success", {
                        detail: {token, form: form}
                    });
                    formWrapper.dispatchEvent(event);
                    form.submit();
                })
                .catch((err) => {
                    console.error("[reCAPTCHA] execute() fehlgeschlagen:", err);
                });
        });
    });

    initFormFields(formWrapper);
}

export function initRecaptchaForms(wrapper = document) {
    const observer = new MutationObserver(function (mutationList) {
        for (const mutation of mutationList) {
            const target = mutation.target;
            if (target) {
                loadRecaptchaHtml(target);
            }
        }
    });

    for (const form of wrapper.querySelectorAll('.js-RecaptchaForm')) {
        observer.observe(form, {
            attributes: true,
            childList: false,
            subtree: false
        });

        // Das Consent-Script kann data-html schon gesetzt haben, bevor der Observer
        // registriert war. Dann kommt keine Mutation mehr und das Formular bliebe leer.
        if (form.dataset.html) {
            loadRecaptchaHtml(form);
        }
    }
}
